export default "__VITE_ASSET__3992784a__"